import { useState } from "react";
import { Link } from "react-router-dom";
import imgeight from "../../assets/img/imgeight.png";
import imgnine from "../../assets/img/imgnine.png";
import imgten from "../../assets/img/imgten.png";
import RoadmapModal from "./RoadmapModal";
import ProfileModal from "./ProfileModal";

const HowItWorks = () => {
  const [showRoadmapModal, setShowRoadmapModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <section className="py-16 px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3  gap-12 items-center">
          {/* Left Column - Large Illustration */}
          <div
            data-aos="fade-right"
            data-aos-duration="2000"
            className="lg:col-span-1 "
          >
            <div
              style={{
                boxShadow:
                  "4px -4px 15px rgba(0, 0, 0, 0.08), 2px -2px 6px rgba(0, 0, 0, 0.05)",
              }}
              className=" bg-white lg:block md:block hidden  px-8 py-12 text-center rounded-[32px]"
            >
              <img
                src={imgeight}
                alt="Girl learning with laptop"
                className="w-full h-auto max-w-sm mx-auto  "
              />
            </div>
          </div>
          {/* Middle Column - Cards */}
          <div className="lg:col-span-1 space-y-8 ">
            {/* Course Structure Card */}
            <div
              data-aos="fade-up-right"
              data-aos-duration="2000"
              className="bg-white py-4 px-8 rounded-2xl"
              style={{
                boxShadow:
                  "3px -3px 12px rgba(0, 0, 0, 0.06), 1px -1px 4px rgba(0, 0, 0, 0.03)",
              }}
            >
              <div className="">
                <img
                  src={imgnine || "/placeholder.svg"}
                  alt="Course Structure"
                  className="w-[167.51px] h-[140px] mb-4"
                />
                <h3 className="text-xl font-medium text-[#113296] font-Outfit mb-2">
                  Course Structure
                </h3>
                <p className="text-[#1B1B1BB2] font-DM_SANS font-normal text-base mb-4">
                  Check out our courses
                </p>
                <Link
                  to="/kids/all-courses"
                  className="bg-[#FF4B01] font-Outfit font-normal text-xl hover:bg-orange-400 text-white px-6 py-1 rounded-full transition-colors duration-200"
                >
                  See more
                </Link>
              </div>
            </div>
            {/* Course Roadmap Card */}
            <div
              data-aos="fade-down"
              data-aos-duration="2000"
              className="bg-white py-4 px-8 rounded-2xl"
              style={{
                boxShadow:
                  "3px -3px 12px rgba(0, 0, 0, 0.06), 1px -1px 4px rgba(0, 0, 0, 0.03)",
              }}
            >
              <div className="">
                <img
                  src={imgten || "/placeholder.svg"}
                  alt="Course Roadmap"
                  className="w-[150px] h-[150px] mb-4"
                />
                <h3 className="text-xl font-medium text-[#113296] font-Outfit mb-2">
                  Course Roadmap
                </h3>
                <p className="text-[#1B1B1BB2] font-DM_SANS font-normal text-base mb-4">
                  Explore our full course <br /> roadmap.
                </p>
                <button
                  onClick={() => setShowRoadmapModal(true)}
                  className="bg-[#FF4B01] font-Outfit font-normal text-xl hover:bg-orange-400 text-white px-6 py-1 rounded-full transition-colors duration-200"
                >
                  View Roadmap
                </button>
              </div>
            </div>
          </div>
          {/* Right Column - Text Content */}
          <div className="lg:col-span-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              How It <span className="text-orange-500">Works</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              Simply explore our range of engaging tech programs, choose the
              course that fits your child's interest and age group, and register
              online in just a few simple steps.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setShowProfileModal(true)} // Open ProfileModal
                className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-4 rounded-full font-semibold transition-colors duration-200"
              >
                Download our Profile
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Roadmap Modal */}
      <RoadmapModal
        isOpen={showRoadmapModal}
        onClose={() => setShowRoadmapModal(false)}
      />
      {/* Profile Modal */}
      <ProfileModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </section>
  );
};

export default HowItWorks;

// import { useState } from "react";
// import { Link } from "react-router-dom";
// import imgeight from "../../assets/img/imgeight.png";
// import imgnine from "../../assets/img/imgnine.png";
// import imgten from "../../assets/img/imgten.png";
// import RoadmapModal from "./RoadmapModal";

// const HowItWorks = () => {
//   const [showRoadmapModal, setShowRoadmapModal] = useState(false);

//   const handleProfileDownload = () => {
//     // Create profile content since the PDF doesn't exist
//     const profileContent = `
// CEPHAS ICT HUB - KIDS TECH EXTRA PROFILE

// About Us:
// Cephas Digital, Adjacent Seventh day Adventist Student Fellowship, Under G, Ogbomoso, Nigeria.

// Our Mission:
// Training, Building and Promoting for Community Development and Global Excellence

// Programs Offered:
// - Digital Literacy
// - Web Design
// - Video Animation
// - Product Design
// - Python Programming

// Age Range: 8-17 years
// Duration: 4 weeks per course
// Price: ₦35,000 per course

// Contact Information:
// Phone: +2348141335945
// Email: cephasict@gmail.com
// Website: www.cephasict.com

// Social Media: @cephasicthub

// Shaping Young Minds into Tomorrow's Tech Innovators!
//     `;

//     const blob = new Blob([profileContent], { type: "text/plain" });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "CEPHAS-KIDS-TECH-EXTRA-Profile.txt";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   };

//   return (
//     <section className="py-16 px-8 bg-white">
//       <div className="max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-center">
//           {/* Left Column - Large Illustration */}
//           <div className="lg:col-span-1">
//             <div
//               style={{
//                 boxShadow:
//                   "4px -4px 15px rgba(0, 0, 0, 0.08), 2px -2px 6px rgba(0, 0, 0, 0.05)",
//               }}
//               className=" bg-white px-8 py-12 text-center rounded-[32px]"
//             >
//               <img
//                 src={imgeight || "/placeholder.svg"}
//                 alt="Girl learning with laptop"
//                 className="w-full h-auto max-w-sm mx-auto "
//               />
//             </div>
//           </div>

//           {/* Middle Column - Cards */}
//           <div className="lg:col-span-1 space-y-8">
//             {/* Course Structure Card */}
//             <div
//               className="bg-white py-4 px-8 rounded-2xl"
//               style={{
//                 boxShadow:
//                   "3px -3px 12px rgba(0, 0, 0, 0.06), 1px -1px 4px rgba(0, 0, 0, 0.03)",
//               }}
//             >
//               <div className="">
//                 <img
//                   src={imgnine}
//                   alt="Course Structure"
//                   className="w-[167.51px] h-[140px] mb-4"
//                 />
//                 <h3 className="text-xl font-medium text-[#113296] font-Outfit mb-2">
//                   Course Structure
//                 </h3>
//                 <p className="text-[#1B1B1BB2] font-DM_SANS font-normal text-base mb-4">
//                   Check out our courses
//                 </p>
//                 <Link
//                   to="/kids/all-courses"
//                   className="bg-[#FF4B01] font-Outfit font-normal text-xl hover:bg-orange-400 text-white px-6 py-1 rounded-full transition-colors duration-200"
//                 >
//                   See more
//                 </Link>
//               </div>
//             </div>

//             {/* Course Roadmap Card */}
//             <div
//               className="bg-white py-4 px-8 rounded-2xl"
//               style={{
//                 boxShadow:
//                   "3px -3px 12px rgba(0, 0, 0, 0.06), 1px -1px 4px rgba(0, 0, 0, 0.03)",
//               }}
//             >
//               <div className="">
//                 <img
//                   src={imgten}
//                   alt="Course Roadmap"
//                   className="w-[150px] h-[150px] mb-4"
//                 />
//                 <h3 className="text-xl font-medium text-[#113296] font-Outfit mb-2">
//                   Course Roadmap
//                 </h3>
//                 <p className="text-[#1B1B1BB2] font-DM_SANS font-normal text-base mb-4">
//                   Explore our full course <br /> roadmap.
//                 </p>
//                 <button
//                   onClick={() => setShowRoadmapModal(true)}
//                   className="bg-[#FF4B01] font-Outfit font-normal text-xl hover:bg-orange-400 text-white px-6 py-1 rounded-full transition-colors duration-200"
//                 >
//                   View Roadmap
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Text Content */}
//           <div className="lg:col-span-1">
//             <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
//               How It <span className="text-orange-500">Works</span>
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-8">
//               Simply explore our range of engaging tech programs, choose the
//               course that fits your child's interest and age group, and register
//               online in just a few simple steps.
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4">
//               <button
//                 onClick={handleProfileDownload}
//                 className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-4 rounded-full font-semibold transition-colors duration-200"
//               >
//                 Download our Profile
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Roadmap Modal */}
//       <RoadmapModal
//         isOpen={showRoadmapModal}
//         onClose={() => setShowRoadmapModal(false)}
//       />
//     </section>
//   );
// };

// export default HowItWorks;
